/**
 * zod schemas for every client → server WebSocket payload.
 *
 * The Connection Manager parses incoming payloads through these BEFORE any
 * game-logic handler is invoked (NFR-003). Invalid payloads are rejected and
 * logged.
 */
import { z } from 'zod';
/** Payload for `player:move`. */
export const playerMoveSchema = z.object({
    direction: z.enum(['up', 'down', 'left', 'right']),
});
const battleActionAttackSchema = z.object({
    type: z.literal('attack'),
    moveId: z.string().min(1),
});
const battleActionBagSchema = z.object({
    type: z.literal('bag'),
    itemId: z.string().min(1),
});
const battleActionRunSchema = z.object({
    type: z.literal('run'),
});
const battleActionSwitchSchema = z.object({
    type: z.literal('switch'),
    targetCreatureId: z.string().min(1),
});
/** Discriminated union mirroring `BattleAction` in `types.ts`. */
export const battleActionSchema = z.discriminatedUnion('type', [
    battleActionAttackSchema,
    battleActionBagSchema,
    battleActionRunSchema,
    battleActionSwitchSchema,
]);
/** Payload for `battle:action`. */
export const battleActionPayloadSchema = z.object({
    battleId: z.string().min(1),
    action: battleActionSchema,
});
/** Payload for `pvp:challenge`. */
export const pvpChallengeSchema = z.object({
    targetPlayerId: z.string().min(1),
});
//# sourceMappingURL=schemas.js.map